import { useAtomValue } from "jotai";

import { rosettaAtom } from "scmp-app/lib/rosetta";

export const useSubscriberOnboarding = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const rosettaInstance = asyncRosettaState?.result?.instance;

  return {
    shouldShowSubscriberOnboarding:
      (asyncRosettaState?.result?.isScmpSubscriber &&
        !!rosettaInstance?.rulesEngine.getOutcome("ui.popup.showSubscriberOnboarding") &&
        !!rosettaInstance?.getService("onboarding")) ??
      false,
    subscriberOnboardingService: rosettaInstance?.getService("onboarding"),
  };
};
